import React from 'react';
import { Skeleton, Stack } from '@mui/material';

export const TabContentSkeleton = () => {
  return (
    <Stack spacing={2.5}>
      {Array.from({ length: 3 }).map((_, idx) => (
        <Skeleton key={idx} variant="rounded" height={130} sx={{ borderRadius: 3 }} />
      ))}
    </Stack>
  );
};
